import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { login } from '../core/Api';

const AuthCallback = () => {
  const [error, setError] = React.useState<Error | null>(null);
  const location = useLocation();
  const navigate = useNavigate();
  const query = React.useMemo(() => {
    const parsedQuery: Record<string, string> = {};
    const queryFragments = location.search.slice(1)
      .split('&');

    for (const fragment of queryFragments) {
      const [key, value] = fragment.split('=');
      parsedQuery[key] = value;
    }

    return parsedQuery;
  }, [location.search]);

  const token = React.useMemo(
    () => query.token || null,
    [query],
  );

  React.useEffect(() => {
    login(token)
      .then(() => {
        navigate('/');
      })
      .catch((error) => {
        setError(error);
      });
  }, [token]);

  if (!token) {
    throw new Error('Ingen login-token fundet.');
  }

  if (error) {
    throw error;
  }

  return (
    <div />
  );
};

export default AuthCallback;
